import React, { createContext, useContext, useState } from "react";
import { MOCK_UNIVERSITIES } from "../mock/mockData";

const TenantContext = createContext(null);

export const TenantProvider = ({ children }) => {
  const [userRole, setUserRole] = useState("UNIVERSITY_MANAGER");
  const [currentTenantId, setCurrentTenantId] = useState(1);

  const universities = MOCK_UNIVERSITIES;

  const currentUniversity =
    userRole === "UNIVERSITY_MANAGER"
      ? universities.find((u) => u.id === currentTenantId) || null
      : null;

  const switchToSuperAdmin = () => {
    setUserRole("SUPER_ADMIN");
    setCurrentTenantId(null);
  };

  const switchToUniversityManager = (universityId) => {
    setUserRole("UNIVERSITY_MANAGER");
    setCurrentTenantId(universityId);
  };

  return (
    <TenantContext.Provider
      value={{
        userRole,
        currentTenantId,
        currentUniversity,
        universities,
        switchToSuperAdmin,
        switchToUniversityManager,
        isSuperAdmin: userRole === "SUPER_ADMIN",
        isUniversityManager: userRole === "UNIVERSITY_MANAGER",
      }}
    >
      {children}
    </TenantContext.Provider>
  );
};

export const useTenant = () => {
  const ctx = useContext(TenantContext);
  if (!ctx) throw new Error("useTenant must be used inside TenantProvider");
  return ctx;
};
